import React from 'react';
import clsx from "clsx";
import {withStyles} from '@mui/styles';


const styles = theme => ({
  root: {
    width: '100%',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  input: {
    display: 'none',
  },
  button: {
    border: '1px solid #6D6D6D',
    padding: '8px 16px',
    fontSize: '0.8568rem',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  fileName: {
    marginLeft: '12px',
    fontSize: '0.8568rem',
    color: '#333',
  },
  error: {
    '& $button': {
      background: 'rgba(255, 0, 0, 0.2)',
      borderColor: '#ff0000',
    }
  }
});

const FileInput = props => {
  const { classes, inputId, value, handleInputs, error, accept, label } = props;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a synthetic event that matches the expected format
      const syntheticEvent = {
        target: {
          name: inputId,
          value: file,
          files: [file]
        }
      };
      handleInputs(syntheticEvent);
    }
  };

   let displayFileName = '';
  if (value instanceof File) {
    displayFileName = value.name;
  } else if (value && typeof value === 'string') {
    displayFileName = '';
  }

  try {
    if (!displayFileName && props.input && props.input.originalName) {
      displayFileName = props.input.originalName;
    }

    if (!displayFileName && props.inputsByHash && inputId) {
      const originalId = inputId.replace(/Filename$/, 'OriginalFileName');
      const altId1 = inputId + 'OriginalName';
      const altId2 = inputId + 'OriginalFileName';
      const candidates = [originalId, altId1, altId2];
      for (let id of candidates) {
        if (props.inputsByHash && props.inputsByHash[id] && props.inputsByHash[id].value) {
          const v = props.inputsByHash[id].value;
          if (typeof v === 'string' && v.trim()) {
            displayFileName = v;
            break;
          }
        }
      }
    }
  } catch (e) {
  }

  return (
    <div className={clsx(classes.root, { [classes.error]: error })}>
      <label className={classes.label}>
        <input
          type="file"
          className={classes.input}
          onChange={handleFileChange}
          name={inputId}
          accept={accept || "image/*"}
        />
        <span className={classes.button}>
          {label || 'Choose File'}
        </span>
        {displayFileName && (
          <span className={classes.fileName}>{displayFileName}</span>
        )}
      </label>
    </div>
  );
}

FileInput.defaultProps = {
  accept: "image/*",
  label: "Choose File",
  value: null,
}

export default withStyles(styles)(FileInput);
